export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'slot',
      name: 'currency',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Direction',
    },
    cell: {
      type: 'slot',
      name: 'direction',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Turnover',
    },
    cell: {
      type: 'slot',
      name: 'turnover',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Payout',
    },
    cell: {
      type: 'slot',
      name: 'payout',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Trades',
    },
    cell: {
      type: 'slot',
      name: 'trades',
    },
  },
];
